<draggable-container [prefix]="data.prefix">
  <div class="d-flex justify-content-center">
    <label [for]="data.prefix+'File'" class="btn btn-levelab btn-outline-levelab me-1">

      <div class="text-center w-100">
        <span class="file-icon" *ngIf="!!data.src">
          <i class={{data.iconClass}}></i>
        </span>
        Seleccionar archivo
      </div>
    </label>
    <!--
https://stackoverflow.com/questions/11832930/html-input-file-accept-attribute-file-type-csv
-->
    <input type="file" name="file" class="form-control mb-1"
      accept=".xlsx, .xls, .xlsm, .csv, .pdf, .doc, .odt, .docx, .ppt, .pptx, .pptm, .pbix, .txt, .png, .jpg, .jpeg" [id]="data.prefix+'File'"
      required="required" hidden (change)="onFileSelected($event)">
  </div>
  <label [for]="data.prefix+'Filename'">
    <span>Nombre del archivo</span>
  </label>
  <input [disabled]="!data.src||data.src===''" type="text" name="alt" class="form-control mb-1"
  [id]="data.prefix+'Filename'" [(ngModel)]="data.filename"
  maxlength="60">
</draggable-container>
